import React, { Component } from 'react';
import './Buildingexterior.css';

class Buildingexterior extends Component {
  constructor(props) {
    super(props);
    this.state = {
    buildjanhr: '8',
    buildfebhr: '8',
    buildmarhr: '8',
    buildaprhr: '8',
    buildmayhr: '8',
    buildjunhr: '8',
    buildjulhr: '8',
    buildaughr: '8',
    buildsephr: '8',
    buildocthr: '8',
    buildnovhr: '8',
    builddechr: '8'

    }
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, );
  }

  render() {
    return (
      <div>
        <div>
          <div className="Calendar-Container">
            {/* occ hours*/}
            <div>
            <div className="occ-bold">Bldg Exterior Hours:</div>
              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildjanhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildjanhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildfebhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildfebhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildmarhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildmarhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildaprhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildaprhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildmayhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildmayhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildjunhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildjunhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildjulhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildjulhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildaughr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildaughr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildsephr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildsephr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildocthr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildocthr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="buildnovhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.buildnovhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="bld-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="builddechr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.builddechr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

            </div>
            {/*end  occhours */}

            
          </div>

        </div>
      </div>
    );
  }
}

export default Buildingexterior;


// WEBPACK FOOTER //
// ./src/components/Buildingexterior.js